<template>
    <div>
        <b-field>
            <b-select v-model="groupId" @input="chosen()" expanded>
                <option disabled value="" selected>{{ t["choose"] }}</option>
                <option v-for="(g, i) in data" :value="g.id" :key="i" :disabled="!g.isAvailable">
                    {{ g.name }} {{ g.isAvailable ? "" : " (ausgebucht)" }}
                </option>
            </b-select>
        </b-field>
        <div class="columns is-multiline" v-if="group">
            <div class="column is-half">
                <b-field :label="t['part1']" :message="`${t['freeplaces']}: ${group.courses[0].freeplaces}`">
                    <b-input disabled :value="date(group.courses[0].isoDate)" expanded />
                </b-field>
            </div>
            <div class="column is-half">
                <b-field :label="t['part2']" :message="`${t['freeplaces']}: ${group.courses[1].freeplaces}`">
                    <b-input disabled :value="date(group.courses[1].isoDate)" expanded />
                </b-field>
            </div>
            <div class="column is-half">
                <b-field :label="t['part3']" :message="`${t['freeplaces']}: ${group.courses[2].freeplaces}`">
                    <b-input disabled :value="date(group.courses[2].isoDate)" expanded />
                </b-field>
            </div>
            <div class="column is-half">
                <b-field :label="t['part4']" :message="`${t['freeplaces']}: ${group.courses[3].freeplaces}`">
                    <b-input disabled :value="date(group.courses[3].isoDate)" expanded />
                </b-field>
            </div>
            <div class="column is-full" v-if="languageId != 'en'">
                <b-field :label="t['ondemand']" :message="t['ondemand.hint']">
                    <b-input v-model="form.onDemand" expanded />
                </b-field>
            </div>
        </div>
    </div>
</template>

<script>
import Resources from "./Resources";
import moment from "moment";
import WidgetUI from "../WidgetUI";

export default {
    props: ["data", "languageId", "form"],
    data: () => ({
        groupId: "",
        group: null,
        t: {},
        e: {},
    }),
    mixins: [WidgetUI],
    created() {
        this.t = Resources[this.languageId == "en" ? "en" : "de"];
    },
    methods: {
        moment,
        date(d) {
            const from = moment(d);
            const to = moment(from).add(2, "hours");

            return from.format("DD.MM.YYYY HH:mm") + " - " + to.format("HH:mm");
        },
        chosen() {
            this.group = this.data.find(g => g.id === this.groupId);
            this.form.courseIds = this.group.courses.map(c => c.id);
        }
    }
}
</script>